function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#7C60D9",
  d: "M18.8077827,15.381622 L21,21.8138474 L17.1149115,21.2712825 L14.3447345,24 L12.2650797,17.8980463 L18.8077827,15.381622 Z M11.7349203,17.8980463 L9.65526549,24 L6.8850885,21.2712825 L3,21.8138474 L5.19221731,15.381622 L11.7349203,17.8980463 Z M12,16 L5.5,13.5 L4,8 L5.5,2.5 L12,-5.32907052e-15 L18.5,2.5 L20,8 L18.5,13.5 L12,16 Z M10.6883726,9.32523581 L8.28234139,6.82352941 L7,8.15686275 L9.5651074,10.8230879 L10.680697,12 L17,5.33333333 L15.7361394,4 L10.6883726,9.32523581 Z"
});

var SvgRibbonVerified = function SvgRibbonVerified(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRibbonVerified, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RibbonVerified.a1ab91f2.svg";
export { ForwardRef as ReactComponent };